export default __webpack_public_path__ + "static/media/nov2023-3.dd2afa6a.jpg";